function _push(eventData) {
    if (!window.dataLayer) return
    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push(eventData)
}

function _calcValue(items) {
    return items.reduce((sum, item) => sum + (item.price ?? 0) * (item.quantity ?? 1), 0)
}

export function mapBasketItemToGa4(basketItem, index) {
    const variant = basketItem.variantData?.variant
    const price = variant?.price?.priceAmount ?? 0
    const listPrice = variant?.price?.listPriceAmount
    const discount = listPrice && listPrice > price ? Math.round((listPrice - price) * 100) / 100 : 0
    const item = {
        item_id: variant?.sku ?? basketItem.data?.productNumber,
        item_name: basketItem.data?.title,
        item_brand: 'cancer.dk',
        item_list_id: 'product_grid_3col',
        item_list_name: 'Produkt oversigt',
        price,
        discount,
        quantity: variant?.quantity ?? 1,
        index
    }
    if (variant?.displayName) item.item_variant = variant.displayName
    return item
}

export function trackViewItem(item) {
    _push({
        event: 'view_item',
        ecommerce: {
            currency: 'DKK',
            value: item.price ?? 0,
            items: [item]
        }
    })
}

export function trackSelectItem(item, listName) {
    _push({
        event: 'select_item',
        ecommerce: {
            item_list_name: listName,
            item_list_id: listName,
            items: [item]
        }
    })
}

export function trackAddToCart(items) {
    _push({
        event: 'add_to_cart',
        ecommerce: {
            currency: 'DKK',
            value: _calcValue(items),
            items
        }
    })
}

export function trackRemoveFromCart(items) {
    _push({
        event: 'remove_from_cart',
        google_business_vertical: 'retail',
        ecommerce: {
            currency: 'DKK',
            value: _calcValue(items),
            items
        }
    })
}

export function trackViewCart(items) {
    _push({
        event: 'view_cart',
        ecommerce: {
            currency: 'DKK',
            value: _calcValue(items),
            items
        }
    })
}

export function trackBeginCheckout(items) {
    _push({
        event: 'begin_checkout',
        ecommerce: {
            currency: 'DKK',
            value: _calcValue(items),
            items
        }
    })
}

export function trackAddShippingInfo(items, shippingTier) {
    _push({
        event: 'add_shipping_info',
        ecommerce: {
            currency: 'DKK',
            value: _calcValue(items),
            shipping_tier: shippingTier,
            items
        }
    })
}

export function trackAddPaymentInfo(items, paymentType) {
    _push({
        event: 'add_payment_info',
        ecommerce: {
            currency: 'DKK',
            value: _calcValue(items),
            payment_type: paymentType,
            items
        }
    })
}
